import { View } from '@mairistem/planning';
import _ from 'lodash';

const viewFrenchToConstant = (view) => {
  switch (_.toLower(view)) {
    case 'jour': return View.DAY;
    case 'semaine': return View.WEEK;
    case 'mois': return View.MONTH;
    default: return null;
  }
};

export default viewFrenchToConstant;
